<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [width_class]="getToolbarWidthClass()"
      [current_nav_item]="current_nav_item"></app-toolbar>

    <div
      class="sp-page__with-absolute-toolbar sp-archived-companies__grid sp-grid__gap sp-padding__x2"
      [ngClass]="areFiltersSet() ? 'sp-archived-companies__grid-with-filters' : 'sp-archived-companies__grid'">
      <app-archived-companies-header
        (refresh)="onRefresh()"
        (filter)="onFilter()"></app-archived-companies-header>

      <app-archived-companies-filters
        *ngIf="areFiltersSet()"
        [filters]="filters"
        (filter_clear)="onFilterClear($event)"></app-archived-companies-filters>

      <app-archived-companies-data (refresh)="onRefresh()"></app-archived-companies-data>
    </div>
  </div>
</div>
